import get from 'lodash/get';

import Decimal from '../app/src/data/base/Decimal';
import Modules from '../shared_modules/Modules';
import { createReactRenderer } from 'helpers/react-renderer';
import OptInModal from 'root/apps/SavedCards/OptInModal';

import AddSavedCardMotoModal from '../AddSavedCardMotoModal';
import ManualPaymentModal from './components/manual-payment/ManualPaymentModal';

/* eslint-disable */
let _currentRenderedComponent = null;
let _currentMountedComponent = null;
let _amount = null;
let _saleManager = null;
let _paymentProvider = null;
let _customerId = null;
let _customerAcknowledgedCardOnFile = false;
let _canOptIntoCardOnFile = false;
let _userJustOptedIn = false;
let _saleId = null;
/* eslint-enable */

export default class ManualPayment {
  static doManualPayment(amount, saleManager, paymentProvider) {
    _amount = amount;
    _saleManager = saleManager;
    _paymentProvider = paymentProvider;
    _saleId = get(saleManager, 'sale.id');

    const hasRegisterUseStoredCardOnFileRight = window.merchantos.session.hasRight(
      'register_use_stored_card_on_file'
    );

    window.lsCloud.Options.get([
      'customer_use_card_on_file',
      'customer_acknowledged_card_on_file',
    ]).done((cofOptions) => {
      const cofOptInEnabled = cofOptions[0] === '1';
      _customerAcknowledgedCardOnFile = cofOptions[1] === '1';

      _canOptIntoCardOnFile =
        window.merchantos.session.hasRight('admin') &&
        (window.merchantos.session.hasRight('admin_shops') ||
          window.merchantos.session.hasRight('admin_employees'));

      // If COF module doesn't exist, force the above settings to prevent banner from showing.
      if (!Modules.hasModule('customer.card_on_file')) {
        _customerAcknowledgedCardOnFile = true;
        _canOptIntoCardOnFile = false;
      }

      // We've got a vNext modal we're guarding behind one of two modules.
      if (
        Modules.hasModule('customer.card_on_file') &&
        (_userJustOptedIn || (cofOptInEnabled && hasRegisterUseStoredCardOnFileRight))
      ) {
        // Only set the customer ID for COF merchants as it enables the card save flow.
        _customerId = get(saleManager, 'customer.id');
        this.showAddSavedCardMotoModal();
      } else if (Modules.hasModule('payments.prefer_moto_widget')) {
        this.showAddSavedCardMotoModal();
      } else {
        _customerId = get(saleManager, 'customer.id');
        this.showManualPaymentModal();
      }
    });
  }

  static showAddSavedCardMotoModal() {
    _currentRenderedComponent = createReactRenderer({
      component: AddSavedCardMotoModal,
      selector: '[data-react-root="ReactModal"]',
      props: {
        customerId: _customerId,
        outletId: _paymentProvider?.activeGatewayPli ?? '',
        saleId: _saleId,
        amount: new Decimal(_amount),
        saleManager: _saleManager,
        onComplete: () => {
          // eslint-disable-next-line no-undef
          window.App.channel.vent.trigger(window.App.globalEvents.register.SHOW_PAYMENTS);
          this.dismissAllModals();
        },
        onRequestClose: () => {
          this.dismissAllModals();
        },
      },
    });

    _currentMountedComponent = _currentRenderedComponent.mount();
  }

  static showManualPaymentModal() {
    const contact = _saleManager.customer ? _saleManager.customer.get('Contact') : {};
    const cardHolderName = _saleManager.customer ? _saleManager.customer.fullName : '';

    _currentRenderedComponent = createReactRenderer({
      component: ManualPaymentModal,
      selector: '[data-react-root="ReactModal"]',
      props: {
        onHide: () => {
          this.dismissAllModals();
        },
        onDone: () => {
          window.App.channel.vent.trigger(window.App.globalEvents.register.SHOW_PAYMENTS);
          this.dismissAllModals();
        },
        amount: _amount,
        balance: _saleManager.pendingBalance,
        orderID: get(_saleManager, 'sale.id'),
        customerID: _customerId,
        postalCode: get(contact, 'Addresses.ContactAddress.zip'),
        cardHolderName,
        saleManager: _saleManager,
        paymentProvider: _paymentProvider,
        customerAcknowledgedCardOnFile: _customerAcknowledgedCardOnFile,
        canOptIntoCardOnFile: _canOptIntoCardOnFile,
        manualPaymentParent: this,
      },
    });

    _currentMountedComponent = _currentRenderedComponent.mount();
  }

  static showOptInModal() {
    this.dismissAllModals();

    _currentRenderedComponent = createReactRenderer({
      component: OptInModal,
      selector: '[data-react-root="ReactModal"]',
      props: {
        isOpen: true,
        onRequestClose: () => {
          this.dismissAllModals();
          if (_userJustOptedIn) {
            this.showAddSavedCardMotoModal();
          } else {
            this.showManualPaymentModal();
          }
        },
        onComplete: () => {
          _userJustOptedIn = true;
          _customerAcknowledgedCardOnFile = true;
        },
        swapStepTwoButtonOrder: true,
        closeShouldCloseAllModals: true,
      },
    });

    _currentMountedComponent = _currentRenderedComponent.mount();
  }

  static dismissAllModals() {
    if (_currentRenderedComponent) {
      _currentRenderedComponent.unmount();
      _currentMountedComponent = null;
    }
  }
}
